import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  IGetAppIsValidVersionResponse,
  getAppIsValidVersion,
} from '../../../../../api/etc/appVersion/queries/getAppIsValidVersion';

interface IUseGetAppIsValidVersionQueryProps {
  searchParam: {
    osType?: string;
    version?: string;
  };
}

export const useGetAppIsValidVersionQuery = ({ searchParam }: IUseGetAppIsValidVersionQueryProps) => {
  return useQuery<IGetAppIsValidVersionResponse, AxiosError>(
    ['get_app_is_valid_version', `osType=${searchParam.osType}`, `version=${searchParam.version}`],
    () =>
      getAppIsValidVersion({
        searchParam: { osType: searchParam.osType!, version: searchParam.version! },
      }),
    { enabled: searchParam.osType !== undefined && searchParam.version !== undefined },
  );
};
